import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	className: "chevron-down",
	id: "OUTLINED",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 32 32",
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "chevron",
		children: /* @__PURE__ */ _jsx("path", { d: "M16,21c-0.3,0-0.5-0.1-0.8-0.3l-9.7-7.5C5,12.8,4.9,12,5.3,11.4c0.4-0.5,1.2-0.6,1.8-0.2l8.9,6.9l9-6.9 c0.5-0.4,1.3-0.3,1.8,0.2c0.4,0.5,0.3,1.3-0.2,1.8l-9.8,7.5C16.5,20.9,16.2,21,16,21z" })
	})]
});
const ForwardRef = forwardRef(SvgChevronDown);
export default ForwardRef;
